var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReasonGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6889_3343)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.0003,
    cy: 10.0003,
    r: 8.33333,
    stroke: "#262626",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 5,
    stroke: "#262626",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.99967,
    cy: 9.99967,
    r: 1.66667,
    stroke: "#262626",
    strokeWidth: 1.66667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6889_3343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasonGoal);
export default __webpack_public_path__ + "static/media/reason-goal.78dd6af33e60d0a662de43933d7bc926.svg";
export { ForwardRef as ReactComponent };